const _ = require("lodash");
const moment = require("moment");
const ProfileUtil = require("../../core/util/ProfileUtil");
const Mixpanel = require("../../core/util/Mixpanel");
const AT = require("../../core/vault/ActionTypes");

const getActiveOrRegisteredStudents = function(parentData) {
	return _.pickBy(parentData.students, s => s.isActive || s.everHadBAOAccess);
};

const hasStudentEverBeenActive = function(student) {
	return student.isActive || student.inActiveClasses || student.hasRegistered;
};

const getStudentsWithActivity = function(parentData) {
	return _.pickBy(parentData.students, hasStudentEverBeenActive);
};

const computeRecentStats = function(recentActivity, numDays) {
	const recentStats = {
		timePlayed: {
			total: 0,
			played: 0,
			read: 0,
			watched: 0,
			puzzled: 0,
			other: 0,
		},
		stars: 0,
		xp: 0,
		trophies: 0,
		problemsCorrect: 0,
	};

	_.each(_.range(numDays), i => {
		const offset = numDays - 1 - i;

		const day = moment().subtract(offset, "day");
		const key = day.format("YYYY-MM-DD");
		const dayActivity = ProfileUtil.getDayStats(key, recentActivity);

		if (dayActivity) {
			recentStats.stars += dayActivity.stars;
			recentStats.trophies += dayActivity.trophies;
			recentStats.xp += dayActivity.xp;
			recentStats.timePlayed = {
				total: recentStats.timePlayed.total + dayActivity.timePlayed.total,
				played: recentStats.timePlayed.played + dayActivity.timePlayed.played,
				read: recentStats.timePlayed.read + dayActivity.timePlayed.read,
				watched:
					recentStats.timePlayed.watched + dayActivity.timePlayed.watched,
				puzzled:
					recentStats.timePlayed.puzzled + dayActivity.timePlayed.puzzled,
				other: recentStats.timePlayed.other + dayActivity.timePlayed.other,
			};
			recentStats.problemCorrect += dayActivity.problemCorrect;
		}
	});

	return recentStats;
};

const fitAvatars = function(props) {
	const windowWidth = props.containerDims.windowWidth;
	const numAvatars =
		_.size(getActiveOrRegisteredStudents(props.parentData)) + 1;
	const availableWidth = 0.25 * windowWidth;
	// Match 3.5rem + 0.25rem margin of each avatar see css + selected avatar.
	return 3.5 * 12 * numAvatars + 4.75 * 12 < availableWidth;
};

const getNextPrevStudentID = function(list, currID) {
	const currIndex = _.indexOf(list, currID);
	const nextIndex = currIndex + 1 < list.length ? currIndex + 1 : 0;
	const nextID = nextIndex !== currIndex ? list[nextIndex] : null;

	const prevIndex = currIndex > 0 ? currIndex - 1 : list.length - 1;
	let prevID;
	if (list.length > 2) {
		prevID = prevIndex !== currIndex ? list[prevIndex] : null;
	}

	return {prevID, nextID};
};

// Determines the parent's customer segment based on their answers to options in
// the student registration process. `options` is a list of their choices to
// three questions. See CopyTable.getParentStudentRegistrationCopy for
// questions.
const computeCustomerSegment = function(options) {
	const segments = {
		AAA: "Perpetually Present Homeschool Parent",
		AAB: "Well-Rounded Homeschool Parent",
		ABA: "Witness to Genius Homeschool Parent",
		ABB: "Child Knows Best Homeschool Parent",
		BAA: "Path Paving Parent",
		BAB: "Student Slightly Struggling Parent",
		BBA: "Setting Standards Parent",
		BBB: "Sidelines Supporter Parent",
	};
	return segments[options.join("")];
};

// Utility function to handle parent login as student action
// This can be used by both TopBar and PrimaryRegistrationFinal components
const onClickLoginAsStudent = function(dispatch, student, method) {
	Mixpanel.track("Parent Login As Student", {
		studentId: student.id,
		studentUsername: student.username,
		method,
	});
	// Dispatch the action through the vault system
	dispatch({
		type: AT.IMITATE_STUDENT_REQUEST,
		student,
		method,
	});
};

module.exports = {
	getActiveOrRegisteredStudents,
	hasStudentEverBeenActive,
	getStudentsWithActivity,
	computeRecentStats,
	getNextPrevStudentID,
	fitAvatars,
	computeCustomerSegment,
	onClickLoginAsStudent,
};
